var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stop_info" }, [
    _c(
      "div",
      { staticClass: "bd-callout bd-callout-info" },
      [
        _c(
          "b-tabs",
          _vm._l(_vm.markets, function (market) {
            return _c(
              "b-tab",
              {
                key: market.id,
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "provider" }, [
                            _c("div", {
                              staticClass: "icon",
                              staticStyle: { "max-width": "25px" },
                              domProps: { innerHTML: _vm._s(market.icon) },
                            }),
                            _vm._v(
                              "\n                            " +
                                _vm._s(market.name) +
                                "\n                        "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "pt-2" },
                  [
                    _c(
                      "b-overlay",
                      { attrs: { show: _vm.is_load } },
                      [
                        _vm.filter_by_market(market, _vm.rows).length > 0
                          ? _c("b-table", {
                              staticClass:
                                "table-responsive-xl resolution_table",
                              attrs: {
                                striped: "",
                                items: _vm.filter_by_market(market, _vm.rows),
                                fields: _vm.fields,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "head(filename)",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "status_info",
                                            staticStyle: {
                                              "max-width": "50px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(_vm.__t("O_EXP_IC")) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(filename)",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "img_block rounded",
                                            staticStyle: {
                                              "max-width": "75px",
                                            },
                                          },
                                          [
                                            _vm.obj_to_null(data.item.image)
                                              ? _c("picture", [
                                                  _c("source", {
                                                    attrs: {
                                                      srcset:
                                                        data.item.image.webp,
                                                      type: "image/webp",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("source", {
                                                    attrs: {
                                                      srcset:
                                                        data.item.image.jpeg,
                                                      type: "image/jpeg",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("img", {
                                                    staticStyle: {
                                                      "max-width": "75px",
                                                    },
                                                    attrs: {
                                                      itemprop: "image",
                                                      src: data.item.image.jpeg,
                                                    },
                                                  }),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(title)",
                                    fn: function (data) {
                                      return [
                                        _c("div", {}, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-start w-100 fs-xl mb-2",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "icon-stack fs-xxl mr-2",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "base base-15 icon-stack-3x opacity-100 color-primary-900",
                                                  }),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    staticClass:
                                                      "fal fa-indent icon-stack-1x opacity-100 color-white",
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.obj_to_null(data.item.product)
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(
                                                          data.item.product
                                                            .title
                                                        ) +
                                                        "\n                                            "
                                                    ),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      "\n                                                NOT_FOUND\n                                            "
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-start w-100",
                                            },
                                            [
                                              _vm.obj_to_null(data.item)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "small badge border border-info",
                                                    },
                                                    [
                                                      data.item.is_prod
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.__t(
                                                                  "CATEG:"
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.__t(
                                                                  "GROUP:"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            data.item
                                                              .main_category
                                                              .title
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.obj_to_null(data.item)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "small badge border border-info ml-3",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            data.item
                                                              .product_uniq
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(rest_id)",
                                    fn: function (data) {
                                      return [
                                        data.item.hasOwnProperty("restaurant")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "prod_name fs-xl color-success-600",
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                                             " +
                                                      _vm._s(
                                                        data.item.restaurant
                                                          .title
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "small text-info",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "small badge border border-warning",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              data.item
                                                                .restaurant
                                                                .uniq_id
                                                            ) +
                                                            "\n                                            "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(location)",
                                    fn: function (data) {
                                      return [
                                        data.item.hasOwnProperty("location")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "prod_name fs-xl",
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                                             " +
                                                      _vm._s(
                                                        data.item.location.title
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "small text-info",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "small badge border border-warning",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              data.item.location
                                                                .uniq_id
                                                            ) +
                                                            "\n                                            "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(added)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(data.item.added) +
                                            "\n                                "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(client_id)",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "fs-xl cursor-pointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.remove_stop(
                                                  data.item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-trash",
                                            }),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }